import { Skeleton } from '@wwe-portal/ui/components/skeleton';

export const StatsDetailsSkeleton = () => {
  return (
    <>
      <div className="mt-2 flex items-center justify-center">
        <Skeleton
          style={{
            width: 160,
            height: 32,
          }}
        />
      </div>
      <div className="mt-4 flex flex-col gap-4">
        <Skeleton style={{ height: 70 }} className="w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton style={{ height: 350 }} className="w-full" />
        <Skeleton style={{ height: 40 }} className="w-full" />
        <Skeleton style={{ height: 40 }} className="w-full" />
        <Skeleton style={{ height: 350 }} className="w-full" />
      </div>
    </>
  );
};
